
  const io = new IntersectionObserver((es)=>es.forEach(e=>{
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
  document.querySelectorAll('.rv').forEach(el => io.observe(el));
  const cw = document.getElementById('chartwrap'); if (cw) io.observe(cw);
  // Bulletproof failsafe: reveal anything in view regardless of which element scrolls
  const revealSeen = () => {
    const vh = window.innerHeight;
    document.querySelectorAll('.rv:not(.in)').forEach(el => {
      if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('in');
    });
  };
  ['scroll','wheel','touchmove','resize','load'].forEach(ev =>
    window.addEventListener(ev, revealSeen, { passive: true, capture: true }));
  document.addEventListener('scroll', revealSeen, { passive: true, capture: true });
  const _t0 = performance.now();
  (function poll(t){ revealSeen(); if (t - _t0 < 8000) requestAnimationFrame(poll); })(_t0);
  setInterval(revealSeen, 500);

  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return; cio.unobserve(e.target);
    const el = e.target, target = +el.dataset.count, suf = el.dataset.suffix || '';
    const t0 = performance.now(), dur = 1600;
    (function tick(t) {
      const p = Math.min(1, (t - t0) / dur), v = target * (1 - Math.pow(1 - p, 3));
      el.textContent = Math.round(v) + suf;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }), { threshold: 0.5 });
  document.querySelectorAll('.num').forEach(el => cio.observe(el));

  // FAQ accordion
  document.querySelectorAll('.faq .q').forEach(btn => {
    btn.addEventListener('click', () => {
      const li = btn.parentElement, panel = li.querySelector('.panel');
      const isOpen = li.classList.contains('open');
      document.querySelectorAll('.faq li.open').forEach(o => { o.classList.remove('open'); o.querySelector('.panel').style.maxHeight = '0'; });
      if (!isOpen) { li.classList.add('open'); panel.style.maxHeight = panel.scrollHeight + 'px'; }
    });
  });

  // Sticky buy bar after hero
  const hero = document.querySelector('.hero'), bar = document.getElementById('buybar');
  if (bar) {
    if (hero) {
      new IntersectionObserver(es => es.forEach(e => {
        bar.classList.toggle('show', !e.isIntersecting);
      }), { threshold: 0.05 }).observe(hero);
    } else {
      setTimeout(() => bar.classList.add('show'), 800);
    }
  }

  // Hero parallax
  const heroBg = document.querySelector('.hero img.bg');
  if (heroBg && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    addEventListener('scroll', () => {
      const y = Math.min(scrollY, innerHeight);
      heroBg.style.translate = `0 ${y * 0.12}px`;
    }, { passive: true });
  }

  // Video review cards: swap poster for local video on click
  document.querySelectorAll('.vcard').forEach(card => {
    const play = card.querySelector('.vplay');
    if (!play) return;
    play.addEventListener('click', () => {
      const srcName = card.dataset.video;
      const v = document.createElement('video');
      v.src = srcName; v.controls = true; v.autoplay = true; v.playsInline = true;
      v.addEventListener('error', () => {
        card.classList.remove('playing'); v.remove();
        const slot = card.querySelector('.vslot');
        if (slot) { slot.style.opacity = '1'; slot.style.background = 'rgba(23,17,13,.75)'; }
      });
      card.prepend(v); card.classList.add('playing');
    });
  });
